module.exports = __webpack_public_path__ + "static/media/1.bdd9ced8.png";